import React, {useState, useMemo} from 'react';
import Select from "@amzn/meridian/select";
import SelectOption from "@amzn/meridian/select/select-option";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Box from "@amzn/meridian/box";

/**
 * This component will render Driver Name filter for driver reconciliation screen
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const DriverNameFilter = (props) => {
    const [value, setValue] = useState();
    const [searchQuery, setSearchQuery] = useState();
    const options = props.data;

    const searchRegExp = useMemo(
        () => new RegExp(searchQuery, "i"),
        [searchQuery]
    )
    const matchedOptions = options.filter(
        option => !searchQuery || searchRegExp.test(option.driverName)
    )

    const onValueChange = event => {
        setValue(event);
        props.onChange(event);
    }

    return (
        <Box>
            <Text type="h100">Driver</Text>
            <Box spacingInset="small none none none">
                <Select
                    value={value}
                    onChange={onValueChange}
                    searchQuery={searchQuery}
                    onSearch={setSearchQuery}
                    placeholder={props.placeholder || ""}
                    width={300}>
                    <SelectOption label="All Drivers" value=""/>
                    {matchedOptions.map(option => (
                        <SelectOption
                            label={option.driverName}
                            value={option.driverName}
                            key={option.driverName}
                        />
                    ))}
                    {!matchedOptions.length ? (
                        <Column
                            alignmentVertical="center"
                            spacing="small"
                            spacingInset="xlarge">
                            <Text alignment="center">No results</Text>
                        </Column>
                    ) : null}
                </Select>
            </Box>
        </Box>
    )
}

export default DriverNameFilter;


// WEBPACK FOOTER //
// ./src/component/driverReconciliation/DriverNameFilter.js